module.exports = __webpack_public_path__ + "static/media/galdisa1990.ce12b3a6.jpg";